/* =====================================================
   MPD PRODUCT EXTRAS — mpd-product-extras.js
   File goes in: assets/mpd-product-extras.js
   ===================================================== */

/* ── Live viewer count ── */
function mpdInitLive(sectionId, base) {
  var el = document.getElementById('mpd-live-' + sectionId);
  if (!el) return;
  var n = base + Math.floor(Math.random() * 30);
  el.textContent = n;
  setInterval(function () {
    n = Math.min(240, Math.max(40, n + Math.floor(Math.random() * 9) - 4));
    el.textContent = n;
  }, 3500);
}

/* ── Offer code copy ── */
function mpdCopyCode(code, btn) {
  if (!navigator.clipboard) {
    /* fallback for older browsers */
    var ta = document.createElement('textarea');
    ta.value = code;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    mpdFlashBtn(btn);
    return;
  }
  navigator.clipboard.writeText(code).then(function () {
    mpdFlashBtn(btn);
  });
}
function mpdFlashBtn(btn) {
  var orig = btn.textContent;
  btn.textContent = 'Copied!';
  setTimeout(function () { btn.textContent = orig; }, 1600);
}

/* ── FAQ accordion ── */
function mpdToggleFaq(btn) {
  var answer = btn.nextElementSibling;
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  /* close all in same container */
  var container = btn.closest('.mpd-faq');
  if (container) {
    container.querySelectorAll('.mpd-faq__q').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      b.nextElementSibling.hidden = true;
    });
  }
  if (!isOpen) {
    btn.setAttribute('aria-expanded', 'true');
    answer.hidden = false;
  }
}

/* ── Collapsible tabs ── */
function mpdToggleTab(btn) {
  var body    = btn.nextElementSibling;
  var isOpen  = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!isOpen));
  body.hidden = isOpen;
}

/* ── Better Together ── */
var _mpdMainPrice = {}; /* sectionId → main product price in paise */

function mpdInitBundle(sectionId, mainPriceCents) {
  _mpdMainPrice[sectionId] = mainPriceCents;
  mpdCalcBundle(sectionId);
}

function mpdToggleBundle(checkEl) {
  var row     = checkEl.closest('.mpd-bundle__row');
  var isOn    = checkEl.classList.contains('mpd-bundle__check--on');
  var sectionId = checkEl.closest('.mpd-extras').dataset.productId
                    ? checkEl.closest('[id]').id.replace('mpd-bundle-', '')
                    : null;

  /* find sectionId from parent bundle container id */
  var bundleEl = checkEl.closest('[id^="mpd-bundle-"]');
  var sid = bundleEl ? bundleEl.id.replace('mpd-bundle-', '') : null;

  if (isOn) {
    checkEl.classList.remove('mpd-bundle__check--on');
    checkEl.classList.add('mpd-bundle__check--off');
    row.dataset.checked = 'false';
    checkEl.setAttribute('aria-label',
      checkEl.getAttribute('aria-label').replace('Remove', 'Add'));
  } else {
    checkEl.classList.add('mpd-bundle__check--on');
    checkEl.classList.remove('mpd-bundle__check--off');
    row.dataset.checked = 'true';
  }
  if (sid) mpdCalcBundle(sid);
}

function mpdCalcBundle(sectionId) {
  var container = document.getElementById('mpd-bundle-' + sectionId);
  if (!container) return;

  var rows     = container.querySelectorAll('.mpd-bundle__row');
  var total    = _mpdMainPrice[sectionId] || 0; /* main product always included */
  var original = _mpdMainPrice[sectionId] || 0;

  rows.forEach(function (row) {
    var price = parseInt(row.dataset.price, 10);
    if (!price) return;
    original += price;
    if (row.dataset.checked === 'true') total += price;
  });

  /* 5% bundle discount */
  var discounted = Math.round(total * 0.95);

  var newEl = document.getElementById('mpd-bundle-new-' + sectionId);
  var oldEl = document.getElementById('mpd-bundle-old-' + sectionId);
  if (newEl) newEl.textContent = mpdFormatMoney(discounted);
  if (oldEl) oldEl.textContent = mpdFormatMoney(total);
}

function mpdFormatMoney(cents) {
  var amount = cents / 100;
  return '\u20B9' + amount.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
}

function mpdAddBundle(sectionId) {
  var container = document.getElementById('mpd-bundle-' + sectionId);
  if (!container) return;

  var btn = document.getElementById('mpd-bundle-btn-' + sectionId);
  if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

  var rows       = container.querySelectorAll('.mpd-bundle__row[data-checked="true"]');
  var variantIds = [];
  rows.forEach(function (row) {
    if (row.dataset.variant) variantIds.push(row.dataset.variant);
  });

  if (variantIds.length === 0) {
    if (btn) { btn.textContent = 'Add bundle'; btn.disabled = false; }
    return;
  }

  /* Add all bundle products via Shopify AJAX Cart API */
  var items = variantIds.map(function (id) {
    return { id: parseInt(id, 10), quantity: 1 };
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function (res) { return res.json(); })
    .then(function () {
      /* Dispatch cart update event so Dawn header cart icon updates */
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.location.href = '/cart';
    })
    .catch(function () {
      if (btn) { btn.textContent = 'Add bundle'; btn.disabled = false; }
    });
}